import { render, staticRenderFns } from "./ClassesPanel.vue?vue&type=template&id=57134a1c&"
import script from "./ClassesPanel.vue?vue&type=script&lang=js&"
export * from "./ClassesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports